import React, { useState } from "react"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import styled from "@emotion/styled"
import { Dialog } from "@mui/material"

const StyledNotificationDlg = styled(Dialog)`
  .MuiPaper-root {
    width: min(760px, calc(100vw - 30px));
    min-height: 260px;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 22px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 8px;
    color: var(--cms-text-primary);
    font-size: 14px;
    line-height: 1.55;
  }

  .MuiDialogActions-root {
    padding: 10px 22px 20px;
  }

  .dialog-ok-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(29, 78, 216, 0.22);
  }

  ul {
    margin: 0;
    padding: 0 0 0 18px;
    li {
      margin: 0 0 6px;
      line-height: 1.45;
    }
  }
`

const UseNotificationDialog = () => {
  const [open, setOpen] = useState(false)
  const [bodyContent, setBodyContent] = useState("")

  const onClose = () => {
    setOpen(false)
  }

  const openDlg = (dlgContent) => {
    setBodyContent(dlgContent)
    setOpen(true)
  }

  const content = (
    <StyledNotificationDlg open={open} onClose={onClose}>
      <DialogTitle>System Notification Message</DialogTitle>
      <DialogContent>{bodyContent}</DialogContent>
      <DialogActions>
        <Button
          className="dialog-ok-btn"
          variant="contained"
          onClick={onClose}
        >
          OK
        </Button>
      </DialogActions>
    </StyledNotificationDlg>
  )

  return [content, openDlg]
}

export default UseNotificationDialog
